import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard, faHome } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import shc from "../../assets/images/statistics.png";
import ami from "../../assets/images/pin-point.png";
import reports from "../../assets/images/sheet.png";
import surveydata from "../../assets/images/surveydata.png";
import { Link } from "react-router-dom";
import '../../assets/styles/barhide.css';
import powerbimg from "../../assets/images/power_bi.png";

function AdminAccess() {
  return (
    <>
      <main id="main" className="main AdminAccess">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">

          <nav>
            <h1>Dashboard / MIS</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard / MIS</li>
            </ol>
          </nav>
         
        </div>
        <div className="container-fluid">

          <div className="card">
            <div className="card-body onbordedSchemess">
              <div className="row d-flex min-vh-50 p-5 align-items-center justify-content-center">

                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <Link to="/mapnew">
                      <div className="card-body"><img src={ami} />
                      </div>
                      <h6>GIS Dashboard</h6>
                    </Link>

                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">

                    <Link to={"/Analytics"}>
                      <div className="card-body"><img src={shc} />
                      </div>
                      <h6>
                        Analytics Dashboard</h6>
                    </Link>

                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <Link to="/SchemeReports">
                      <div className="card-body"><img src={reports} />
                      </div>
                      <h6>MIS Reports</h6>
                    </Link>

                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <Link to="/home/surveydata">
                      <div className="card-body"><img src={surveydata} />
                      </div>
                      <h6>Survey Data Count</h6>
                    </Link>
                  </div>
                </div>
                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">

                    <Link to={"/Powerbi"}>
                      <div className="card-body"><img src={powerbimg} />
                      </div>
                      <h6>
                        Power BI Dashboard</h6>
                    </Link>

                  </div>
                </div>
                


              </div>
            </div>
          </div>


        </div>



      </main>

      <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India.
            </a>
          </div>
        </footer> 
    </>
  );
}

export default AdminAccess